import React from 'react';
import './AdminModal.css';

const AdminModal = ({ title, children, onClose }) => (
  <div className="admin-modal-backdrop" role="dialog" aria-modal="true">
    <div className="admin-modal-card">
      <div className="admin-modal-header">
        <h3>{title}</h3>
        <button type="button" className="admin-modal-close" onClick={onClose} aria-label="關閉">×</button>
      </div>
      <div className="admin-modal-body">
        {children}
      </div>
    </div>
  </div>
);

export default AdminModal;
